import SearchHits from './SearchHits';

export default SearchHits;
